var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHidden = function SvgHidden(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M1.218 3.295a.5.5 0 0 0-.477.184l-.432.551a.5.5 0 0 0 .084.702l2.472 1.939a8.9 8.9 0 0 0-1.769 2.61 1.022 1.022 0 0 0 0 .869 8.88 8.88 0 0 0 7.906 5.282 8.9 8.9 0 0 0 3.807-.962l3.321 2.605a.5.5 0 0 0 .702-.085l.432-.55a.5.5 0 0 0-.084-.702l-.527-.413a.5.5 0 0 1-.225-.1zm14.488 8.822a9 9 0 0 0 1.198-1.967 1.022 1.022 0 0 0 0-.869A8.88 8.88 0 0 0 9.002 4a8.9 8.9 0 0 0-2.92.568l1.491 1.17c.45-.185.934-.291 1.43-.309a4.153 4.153 0 0 1 4 4.287q.006.141 0 .281zM11.57 8.872a2.76 2.76 0 0 0-2.56-2.013l-.007-.001h-.001zM5 9.716a4.2 4.2 0 0 1 .15-1.252l1.21.949q-.014.149-.014.297a2.763 2.763 0 0 0 2.662 2.851c.366-.013.722-.099 1.05-.248l1.189.933a4.15 4.15 0 0 1-2.243.757h-.003a4.153 4.153 0 0 1-4-4.287",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHidden);
export default ForwardRef;